/**
 * Build the full collage image list for a bundle card.
 * Returns one representative image per slot (the first eligible product with
 * a thumbnail) PLUS the free gift image, capped at 6 to keep the mini-collage
 * legible. Every slot that has a valid product is represented — no more
 * silent truncation to 4.
 */
export function buildBundleCollage(bundle, catalog) {
  const seen = new Set();
  const collage = [];
  for (const slot of bundle?.slots || []) {
    for (const pid of slot?.eligible_products || []) {
      const p = catalog?.[pid] || catalog?.[String(pid)];
      const img = p?.thumbnail_url;
      if (img && !seen.has(img)) {
        seen.add(img);
        collage.push(img);
        break;
      }
    }
    if (collage.length >= 6) break;
  }
  const gift = catalog?.[bundle?.free_gift_product_id] || catalog?.[String(bundle?.free_gift_product_id)];
  if (gift?.thumbnail_url && !seen.has(gift.thumbnail_url) && collage.length < 6) {
    collage.push(gift.thumbnail_url);
  }
  return collage;
}

/**
 * Tailwind grid class based on collage size (1 to 6). Keeps every tile
 * visible inside an aspect-[4/3] card without cropping any product off.
 */
export function collageGridClass(count) {
  if (count <= 1) return "grid-cols-1";
  if (count === 2) return "grid-cols-2";
  if (count === 3) return "grid-cols-3";
  if (count === 4) return "grid-cols-2";
  return "grid-cols-3"; // 5 or 6
}
